import React from 'react';
import './ProductOffer.scss';

const ProductOffer = ({ text, content, customStyle = {}, textStyle = {} }) => {
  return (
    <div className={`product-offer-label ${content ? 'empty-div' : ''}`} style={customStyle}>
      <div>
        <span className="product-offer-text" style={textStyle}>
          {text}
        </span>
      </div>
    </div>
  );
};

export default ProductOffer;
